import { colors } from '../../styles/variables';

interface MobileAppVersionIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const MobileAppVersionIcon = ({ color = colors.grey700, width = 24, height = 24 }: MobileAppVersionIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="2" width="12" height="20" rx="2" stroke={color} strokeWidth="2" fill="none" />
      <rect x="8" y="5" width="8" height="11" stroke={color} strokeWidth="1.5" fill="none" />
      <circle cx="12" cy="19" r="1" stroke={color} strokeWidth="1.5" fill="none" />
      <path
        d="M12 8L12 13M12 13L10 11M12 13L14 11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MobileAppVersionIcon;
